import React from "react";
import { SvgIcon } from "../Components/SvgIcons";

function IdPasswordChange() {
	return (
		<>
			<div className="overviewTableWrapper">
				<div className="overviewTableChild">
					<div className="d-flex flex-wrap">
						<div className="col-12">
							<div className="heading">
								<div className="content">
									<h4>ID Password Change</h4>
									<p>ID password change of an account</p>
								</div>
								<div className="buttonGroup">
									<button effect="ripple" className="panelButton gray">
										<span className="text">Back</span>
										<span className="icon">
											<SvgIcon name="back" />
										</span>
									</button>
									<button type="button" className="panelButton">
										<span className="text">Save</span>
										<span className="icon">
											<SvgIcon name="save" />
										</span>
									</button>
								</div>
							</div>
						</div>
						<div className="col-12" style={{ padding: "25px 23px" }}>
							<form className="mb-0">
								<div className="formRow col-xl-6">
									<div className="formLabel">
										<label>Username</label>
									</div>
									<div className="col-6">
										<input className="formItem" />
									</div>
								</div>
								<div className="formRow col-xl-6">
									<div className="formLabel">
										<label>New Password</label>
									</div>
									<div className="col-6">
										<input className="formItem" />
									</div>
								</div>
								<div className="formRow col-xl-6">
									<div className="formLabel">
										<label>Confirm Password</label>
									</div>
									<div className="col-6">
										<input className="formItem" />
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default IdPasswordChange;
